<template>
  <div>
    <b-row align-v="center" class="justify-content-start  m-1" no-gutters>
      <b-col cols="1">
        <b-form-select v-model="dayOfWeekType" :options="dayTypeOptions" @change="dayOfWeekTypeSelected" plain/>
      </b-col>
      <b-col cols="2" class="ml-2">
        <b-form-select v-model="openingHourType" :options="breakTimeFlag? breakTimeOption :openingHourOptions" @change="openingHourTypeSelected" plain/>
      </b-col>

      <!--시작시간-->
      <b-col cols="1" class="ml-4">
        <b-form-select v-model="selectedStartHour" :options="hourOptions" @change="changeTime" :disabled="!breakTimeFlag && !HourVisibleFlag" plain/>
      </b-col>
      <b-col cols="1" class="ml-2">
        <b-form-select v-model="selectedStartMinute" :options="minuteOptions" @change="changeTime" :disabled="!breakTimeFlag && !HourVisibleFlag" plain/>
      </b-col>

      <b-col md="auto" class="ml-2">
        <span>~</span>
      </b-col>

      <!--종료시간-->
      <b-col cols="1" class="ml-2">
        <b-form-select v-model="selectedEndHour" :options="hourOptions" @change="changeTime" :disabled="!breakTimeFlag && !HourVisibleFlag" plain/>
      </b-col>
      <b-col cols="1" class="ml-2">
        <b-form-select v-model="selectedEndMinute" :options="minuteOptions" @change="changeTime" :disabled="!breakTimeFlag && !HourVisibleFlag" plain/>
      </b-col>

      <b-col cols="2" class="ml-2">
        <b-form-input v-model="comment" placeholder="예) 1월 1일 휴무"  @change="changeComment"/>
      </b-col>


      <b-col cols="1" class="ml-3">
        <!-- :hidden="params.id < 1" -->
        <b-button variant="outline-success" class="mb-2 mr-sm-3 mb-sm-0" size="xs" @click="onClickDelete" style="white-space: nowrap" >삭제
<!--        <b-button variant="outline-success" class="mb-3 mr-sm-4 mb-sm-0" size="xs" @click="onClickDelete">삭제-->
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  export default {
    props: ['data', 'breakTimeFlag'],
    mounted() {
      this.params.id = this.data.id
      this.dataFormat.id = this.data.id
      this.loadData()
    },
    data() {
      return {
        comment : null,
        params: {
          id: null
        },
        dataFormat: {
          id: "",
          dayOfWeekType: "",
          monday: "",
          tuesday: "",
          wednesday: "",
          thursday: "",
          friday: "",
          saturday: "",
          sunday: "",
          openingHourType: "",
          timeFrom: "",
          timeTo: ""
        },
        dayOfWeekType: null,
        dayTypeOptions: [
          {value: null, text: '--요일--', disabled: true},
          {value: 'Everyday', text: '매일'},
          {value: 'Weekday', text: '주중'},
          {value: 'Weekend', text: '주말'},
          // {value: 'holiday', text: '공휴일'},
          {value: 'monday', text: '월'},
          {value: 'tuesday', text: '화'},
          {value: 'wednesday', text: '수'},
          {value: 'thursday', text: '목'},
          {value: 'friday', text: '금'},
          {value: 'saturday', text: '토'},
          {value: 'sunday', text: '일'},
        ],
        openingHourType: null,
        openingHourOptions: [
          {value: null, text: '--영업--', disabled: true},
          {value: 'RunningTime', text: '영업 시간 입력'},
          {value: 'Open24Hours', text: '24시간 영업'},
          // {value: 'Holiday', text: '휴일'},
        ],
        breakTimeOption: [
          {value: 'BreakTime', text: '휴식시간'},
        ],
        HourVisibleFlag: false,
        selectedStartHour: null,
        selectedEndHour: null,
        hourOptions: [
          {value: null, text: '--시--', disabled: true},
          {value: '00', text: '00 시'},
          {value: '01', text: '01 시'},
          {value: '02', text: '02 시'},
          {value: '03', text: '03 시'},
          {value: '04', text: '04 시'},
          {value: '05', text: '05 시'},
          {value: '06', text: '06 시'},
          {value: '07', text: '07 시'},
          {value: '08', text: '08 시'},
          {value: '09', text: '09 시'},
          {value: '10', text: '10 시'},
          {value: '11', text: '11 시'},
          {value: '12', text: '12 시'},
          {value: '13', text: '13 시'},
          {value: '14', text: '14 시'},
          {value: '15', text: '15 시'},
          {value: '16', text: '16 시'},
          {value: '17', text: '17 시'},
          {value: '18', text: '18 시'},
          {value: '19', text: '19 시'},
          {value: '20', text: '20 시'},
          {value: '21', text: '21 시'},
          {value: '22', text: '22 시'},
          {value: '23', text: '23 시'},
        ],
        selectedStartMinute: null,
        selectedEndMinute: null,
        minuteOptions: [
          {value: null, text: '--분--', disabled: true},
          {value: '00', text: '00 분'},
          {value: '10', text: '10 분'},
          {value: '20', text: '20 분'},
          {value: '30', text: '30 분'},
          {value: '40', text: '40 분'},
          {value: '50', text: '50 분'},
        ]
      }
    },
    methods: {


      loadData() {
        this.dataFormat.comment = this.data.comment
        this.comment = this.data.comment

        if (this.data.dayOfWeekType == "Custom") {
          this.dataFormat.monday = this.data.monday
          if (this.data.monday) {
            this.dayOfWeekType = 'monday'
          }
          this.dataFormat.tuesday = this.data.tuesday
          if (this.data.tuesday) {
            this.dayOfWeekType = 'tuesday'
          }
          this.dataFormat.wednesday = this.data.wednesday
          if (this.data.wednesday) {
            this.dayOfWeekType = 'wednesday'
          }
          this.dataFormat.thursday = this.data.thursday
          if (this.data.thursday) {
            this.dayOfWeekType = 'thursday'
          }
          this.dataFormat.friday = this.data.friday
          if (this.data.friday) {
            this.dayOfWeekType = 'friday'
          }
          this.dataFormat.saturday = this.data.saturday
          if (this.data.saturday) {
            this.dayOfWeekType = 'saturday'
          }
          this.dataFormat.sunday = this.data.sunday
          if (this.data.sunday) {
            this.dayOfWeekType = 'sunday'
          }
          this.dataFormat.dayOfWeekType = 'Custom'

        } else {
          this.dayOfWeekType = this.data.dayOfWeekType
          this.dataFormat.dayOfWeekType = this.data.dayOfWeekType
          this.dataFormat.monday = false
          this.dataFormat.tuesday = false
          this.dataFormat.wednesday = false
          this.dataFormat.thursday = false
          this.dataFormat.friday = false
          this.dataFormat.saturday = false
          this.dataFormat.sunday = false
        }


        this.dataFormat.openingHourType = this.data.openingHourType
        this.openingHourType = this.data.openingHourType


        if (this.data.openingHourType == "Open24Hours") { // 24시간 영업
          this.dataFormat.timeFrom = null
          this.dataFormat.timeTo = null


        }else if(this.data.openingHourType == "Holiday"){ //휴일
          this.dataFormat.timeFrom = null
          this.dataFormat.timeTo = null

        }else if(this.data.openingHourType == "RunningTime" || this.data.openingHourType == "BreakTime"){
          this.HourVisibleFlag = true
          this.dataFormat.timeFrom = this.data.timeFrom
          this.dataFormat.timeTo = this.data.timeTo
          let tempTimeStart = this.data.timeFrom.split(':')
          this.selectedStartHour = tempTimeStart[0]
          this.selectedStartMinute = tempTimeStart[1]
          let tempTimeEnd = this.data.timeTo.split(':')
          this.selectedEndHour = tempTimeEnd[0]
          this.selectedEndMinute = tempTimeEnd[1]

        } else{
        }

      },

      onClickDelete() {
        console.log(this.params.id)
        this.$emit('delete-business-hour', this.params.id)

      },

      dayOfWeekTypeSelected(value) {

        this.dataFormat.monday = false
        this.dataFormat.tuesday = false
        this.dataFormat.wednesday = false
        this.dataFormat.thursday = false
        this.dataFormat.friday = false
        this.dataFormat.saturday = false
        this.dataFormat.sunday = false
        if (value == 'monday') {
          this.dataFormat.monday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else if (value == 'tuesday') {
          this.dataFormat.tuesday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else if (value == 'wednesday') {
          this.dataFormat.wednesday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else if (value == 'thursday') {
          this.dataFormat.thursday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else if (value == 'tuesday') {
          this.dataFormat.tuesday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else if (value == 'wednesday') {
          this.dataFormat.wednesday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else if (value == 'thursday') {
          this.dataFormat.thursday = true
          this.dataFormat.dayOfWeekType = 'Custom'
        } else {
          this.dataFormat.dayOfWeekType = value
        }
        this.$emit('changeData', this.params.id, this.dataFormat)
      },


      openingHourTypeSelected(value) {
        this.dataFormat.openingHourType = value

        if (value == 'RunningTime') {
          this.HourVisibleFlag = true
        } else {
          this.HourVisibleFlag = false
          this.dataFormat.timeFrom = null;
          this.dataFormat.timeTo = null;
          this.selectedStartHour = null;
          this.selectedStartMinute = null;
          this.selectedEndHour = null;
          this.selectedEndMinute = null;
        }
        this.$emit('changeData', this.params.id, this.dataFormat)
      },


      changeTime() {
        if (this.selectedStartHour !== null && this.selectedStartMinute !== null) {
          this.dataFormat.timeFrom = this.selectedStartHour + ":" + this.selectedStartMinute + ":00"
        } else {
          this.dataFormat.timeFrom = null
        }
        if (this.selectedEndHour !== null && this.selectedEndMinute !== null) {
          this.dataFormat.timeTo = this.selectedEndHour + ":" + this.selectedEndMinute + ":00"
        } else {
          this.dataFormat.timeTo = null
        }
        this.$emit('changeData', this.params.id, this.dataFormat)
      },


      changeComment() {
        this.dataFormat.comment = this.comment
        this.$emit('changeData', this.params.id, this.dataFormat)
      },



    }//method
  }
</script>
